import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form, yupToFormErrors } from 'formik';
import { Container, Button, Spinner, Modal, ModalBody, ModalFooter, ModalHeader, Fade } from 'reactstrap';
import VerifikasiDataPribadi from './VerifikasiDataPribadi';
import { Page1PersonalData } from './Page1PersonalData';
import { Page2Address } from './Page2Address';
import Page5AgreementPernyataan from './Page5AgreementPernyataan';
import Page5AgreementKetentuan from './Page5AgreementKetentuan';
import Page6Summary from './Page6Summary';
import Iframe from './Iframe';
import { Page4Job } from './Page4Job';
import { actionCreators as occupationAction } from '../../store/Occupations';
import { positionActions } from '../../store/Position.Reducer';
import { registerActions } from '../../store/Register.Reducer';
import { pengkinianDataActions } from '../../store/PengkinianData.Reducer';
import { businessFieldActions } from '../../store/BusinessField.Reducer';
import { provinceActions } from '../../store/Province.Reducer';
import { cityActions } from '../../store/City.Reducer';
import { bankActions } from '../../store/Bank.Reducer';
import { Prompt } from 'react-router';
import { Persist } from 'formik-persist';
import * as util from 'util'

import * as Yup from "yup";
import { stat } from 'fs';

export let defaultValue = {
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Nationality: '',
    KTPNumber: '',
    KTPExpiredDate: '',
    IsKTPExpired: '',
    NPWPNumber: '',
    BirthPlace: '',
    BirthDate: '',
    ResidentialAddressLine1: '',
    ResidentialAddressLine2: '',
    Address3: '',
    City: '',
    ResidentialAddressprovinceId: '',
    ResidentialAddressProvinceName: '',
    ResidentialAddressCityId: '',
    ResidentialAddressPostalCode: '',
    ResidentialAddressCountry: '',
    ResidentialAddressRT: '',
    ResidentialAddressRW: '',
    Country: '',
    HomePhone: '',
    HomePhone2: '',
    MobilePhone: '',
    HomePhoneAreaCode: '',
    Email: '',
    Fax: '',
    GenderId: '',
    MaritalStatusId: '',
    SpouseName: '',
    HeirName: '',
    HeirRelation: '',
    EducationId: '',
    OccupationId: '',
    BusinessFieldId: '',
    BusinessFieldText: '',
    BusinessFieldOthers: '',
    IncomePerAnnumId: '',
    FundSourceId: '',
    InvestmentObjective: '',
    RTRW: '',
    NPWP: '',
    NPWPLocked: '',
    NPWPAddress1: '',
    PositionId: '',
    PositionText: '',
    PositionOthers: '',
    CompanyName: '',
    CompanyAddress: '',
    CompanyPhoneNumber: '',
    CompanyAreaPhoneNo: '',
    MothersMaidenName: '',
    Religion: '',
    ValidationCode: '',
    PhotoKTP: '',
    LengthOfWork: '',
    AgreementVersion: 'November 2022',
    Initial: '',
};

// tslint:disable-next-line:jsx-key
// const pages = [<Page1PersonalData />, <Page2Address />];

class PengkinianData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: localStorage.getItem('page') || -1, totalPages: 5,
            MaritalStatusId: '',
            PhotoKTP: localStorage.getItem('PhotoKTP') || '',
            PhotoSelfie: localStorage.getItem('PhotoSelfie') || '',
            PhotoSelfieKTP: localStorage.getItem('PhotoSelfieKTP') || '',
            PhotoSpesimen: localStorage.getItem('PhotoSpesimen') || '',
            data: defaultValue,
            norek: '',
            namaPemegangRekening: '',
            imageValidation: '/api/register/image-validation',
            imageHash: '',
            errors: [],
            registerError: false,
            defaultValue: defaultValue, isLoading: false, openModalPhoto: false, PhotoId: '', iframeSrc: '', shouldBlockNavigation: false
        };

        this.nextPage = this.nextPage.bind(this);
        this.sendData = this.sendData.bind(this);
        this.onOccupationChange = this.onOccupationChange.bind(this);
        this.onPositionChange = this.onPositionChange.bind(this);
        this.imageChange = this.imageChange.bind(this);
        this.fotoSpesimen = this.fotoSpesimen.bind(this);
        this.nowRegister = this.nowRegister.bind(this);
        this.onGantiPhotoKTP = this.onGantiPhotoKTP.bind(this);
        this.takePhoto = this.takePhoto.bind(this);
        this.onGantiPhotoNPWP = this.onGantiPhotoNPWP.bind(this);
        this.onSnapPhoto = this.onSnapPhoto.bind(this);
        this.el = React.createRef();
        this.onAgree = this.onAgree.bind(this);
        this.onResidentialProvinceChange = this.onResidentialProvinceChange.bind(this);
        this.onCorrespondenceProvinceChange = this.onCorrespondenceProvinceChange.bind(this);
        this.onCloseMessage = this.onCloseMessage.bind(this);
    }

    componentDidMount() {
        this.props.requestOccupations();
        this.props.requestProvinces();
        const register = JSON.parse(localStorage.getItem("registrasi"));

        if (register) {
            //     if (register.values.ProvinceId !== '') {
            //         this.props.requestCities(register.values.ProvinceId);
            //     }
            if (register.values.OccupationId !== '') {
                this.props.requestPositions(register.values.OccupationId);
            }
            if (register.values.PositionId !== '') {
                this.props.requestBusinessFields(register.values.PositionId, register.values.OccupationId);
            }
            //     if (register.values.CorrespondenceAddressprovinceId !== '') {
            //         this.props.requestCorrespondenceCities(register.values.CorrespondenceAddressprovinceId);
            //     }
            if (register.values.ResidentialAddressprovinceId !== '') {
                this.props.requestResidentialCities(register.values.ResidentialAddressprovinceId);
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.page !== this.state.page) {
            this.ensureDataFetched();
        }
        // this.scrollToBottom();

        // if (this.state.page >= 0) {
        //     window.onbeforeunload = () => true
        // } else {
        //     window.onbeforeunload = undefined
        // }
    }

    imageChange(e, setFieldValue) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        const componentName = e.target.name;

        reader.onloadend = () => {
            this.setState({
                [componentName]: reader.result
            });
        }
        setFieldValue(e.target.name, file);
        // localStorage.setItem([componentName], file);
        if (file != null) {
            reader.readAsDataURL(file);
        } else {
            this.setState({ imagePreviewUrl: '' });
        }
    }

    async nowRegister(data) {
        if (!data || typeof data !== 'object') return;

        defaultValue = {
            ...defaultValue,
            FirstName: data.FirstName,
            MiddleName: data.MiddleName,
            LastName: data.LastName,
            KTPNumber: data.KTPNumber,
            NPWPNumber: data.NPWPNumber,
            BirthPlace: data.BirthPlace,
            BirthDate: data.BirthDate,
            ResidentialAddressLine1: data.ResidentialAddressLine1,
            ResidentialAddressLine2: data.ResidentialAddressLine2,
            Address3: data.Address3,
            City: data.City,
            ResidentialAddressPostalCode: data.ResidentialAddressPostalCode,
            Country: data.Country,
            RTRW: data.RTRW,
            HomePhone: data.HomePhone,
            HomePhone2: data.HomePhone2,
            MobilePhone: data.MobilePhone,
            Email: data.Email,
            Fax: data.Fax,
            GenderId: data.GenderId,
            MaritalStatusId: data.MaritalStatusId,
            SpouseName: data.SpouseName,
            HeirName: data.HeirName,
            HeirRelation: data.HeirRelation,
            EducationId: data.EducationId,
            OccupationId: data.OccupationId,
            BusinessFieldId: data.BusinessFieldId,
            BusinessFieldOthers: data.BusinessFieldOthers,
            BusinessFieldText: data.BusinessFieldText,
            IncomePerAnnumId: data.IncomePerAnnumId,
            FundSourceId: data.FundSourceId,
            InvestmentObjective: data.InvestmentObjective,
            NPWPAddress1: data.NPWPAddress1,
            PositionId: data.PositionId,
            PositionOthers: data.PositionOthers,
            PositionText: data.PositionText,
            Nationality: data.Nationality,
            CompanyName: data.CompanyName,
            CompanyAddress: data.CompanyAddress,
            CompanyPhoneNumber: data.CompanyPhoneNumber,
            CompanyAreaPhoneNo: data.CompanyAreaPhoneNo,
            MothersMaidenName: data.MothersMaidenName,
            ResidentialAddressprovinceId: data.ResidentialAddressprovinceId,
            ResidentialAddressCityId: data.ResidentialAddressCityId,
            ResidentialAddressCountry: data.ResidentialAddressCountry,
            Religion: data.Religion,
            NPWP: data.NPWP,
            ResidentialAddressRT: data.ResidentialAddressRT,
            ResidentialAddressRW: data.ResidentialAddressRW,
            HomePhoneAreaCode: data.HomePhoneAreaCode,
            LengthOfWork: data.LengthOfWork,
            Initial: data.Initial,
            KTPExpiredDate: data.KTPExpiredDate,
            IsKTPExpired: data.IsKTPExpired,
            NPWPLocked: data.NPWP === "2" ? true : false,
        };

        this.setState({ page: 0, MaritalStatusId: data.MaritalStatusId, Religion: data.Religion });
        localStorage.setItem('page', 0);
        this.props.requestResidentialCities(data.ResidentialAddressprovinceId);
        this.props.requestPositions(data.OccupationId);
        this.props.requestBusinessFields(data.PositionId, data.OccupationId);

    }

    onResidentIdemIdentity(e, setFieldValue, values, requestResidentialCities) {
        if (e.target.checked) {
            setFieldValue('ResidentialAddressIdem', true);
            setFieldValue('ResidentialAddressLine1', values.Address1 + values.Address2);
            setFieldValue('ResidentialAddressprovinceId', values.ProvinceId);
            if (values.ProvinceId !== '') {
                requestResidentialCities(values.ProvinceId);
                setFieldValue('ResidentialAddressCityId', values.CityId);
            }
            setFieldValue('ResidentialAddressPostalCode', values.PostalCode);
        } else {
            setFieldValue('ResidentialAddressLine1', '');
            setFieldValue('ResidentialAddressprovinceId', '');
            setFieldValue('ResidentialAddressCityId', '');
            setFieldValue('ResidentialAddressPostalCode', '');
            setFieldValue('ResidentialAddressIdem', false);
        }
    }

    onAgree(e, setFieldValue) {
        const fieldname = e.target.name;
        console.log(fieldname);
        if (e.target.checked) {
            setFieldValue([fieldname], new Date().toISOString());
        } else {
            setFieldValue([fieldname], '');
        }
    }

    onGantiPhotoKTP(e, setFieldValue) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                photoKTP: reader.result
            });
        }
        setFieldValue('PhotoKTP', e.target.files[0]);
        if (file != null) {
            reader.readAsDataURL(file);
        } else {
            this.setState({
                photoKTP: ''
            });
        }
    }

    onGantiPhotoNPWP(e, setFieldValue) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                photoNPWP: reader.result
            });
        }
        setFieldValue('PhotoNPWP', e.target.files[0]);
        if (file != null) {
            reader.readAsDataURL(file);
        } else {
            this.setState({
                photoNPWP: ''
            });
        }
    }

    fotoSpesimen(e, setFieldValue) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                fotoSpesimen: reader.result
            });
        }
        setFieldValue('PhotoSpesimen', e.target.value);
        if (file != null) {
            reader.readAsDataURL(file)
        } else {
            this.setState({ fotoSpesimen: '' });
        }
    }

    ensureDataFetched() {
        // this.props.requestOccupations();
        // this.props.requestProvinces();

    }

    Step1Schema = Yup.object().shape({
        FirstName: Yup.string().required('Nama Depan harus diisi'),
        GenderId: Yup.string().required('Jenis Kelamin harus dipilih'),
        KTPNumber: Yup.string().required('No. KTP harus diisi'),
        Nationality: Yup.string().required('Warga Negara harus dipilih'),
        MaritalStatusId: Yup.string().required('Status Pernikahan harus dipilih'),
        Religion: Yup.string().required('Agama harus dipilih'),
        BirthPlace: Yup.string().required('Tempat Lahir harus diisi'),
        BirthDate: Yup.date().required('Tgl Lahir harus diisi'),
        EducationId: Yup.string().required('Pendidikan Terakhir harus diisi'),
        MothersMaidenName: Yup.string().required('Nama Ibu Kandung harus diisi').max(40, 'Maksimal 40 karakter'),
        NPWP: Yup.string().required('NPWP harus dipilih'),
        PhotoKTP: Yup.string()
            .when('IsKTPExpired', {
                is: (IsKTPExpired) => IsKTPExpired == "true",
                then: Yup.string().required('Harus diisi')
        }),
        //NPWPNumber: Yup.string()
        //    .when('NPWP', {
        //        is: (NPWP) => NPWP !== "1",
        //        then: Yup.string().required('Harus diisi').matches(/^[0-9]+$/, "Must be only digits").min(15, 'Minimal 15 karakter').max(15, 'Maksimal 15 karakter')
        //    }),
        //NPWPAddress1: Yup.string()
        //    .when('NPWP', {
        //        is: (NPWP) => NPWP !== "1",
        //        then: Yup.string().trim().required('Harus diisi').min(4, "Minimal 4 karakter").max(50, 'Maksimal 50 karakter')
        //    }),
        SpouseName: Yup.string()
            .when('MaritalStatusId', {
                is: (MaritalStatusId) => MaritalStatusId === "2",
                then: Yup.string().required('Harus diisi')
            })
    });

    Step2Schema = Yup.object().shape({
        ResidentialAddressCountry: Yup.string().required('Negara harus dipilih'),

        ResidentialAddressRT: Yup.string().required('RT harus diisi').max(3, 'RT harus diisi 3 digit'),
        ResidentialAddressRW: Yup.string().required('RW harus diisi').max(3, 'RW harus diisi 3 digit'),
        HomePhone: Yup.string().trim().matches(/^[0-9]+$/, "Must be only digits").max(10, "Maksimal 10 karakter").required('No. Telp harus diisi'),
        HomePhoneAreaCode: Yup.string().required('Kode Area harus diisi').min(3, 'No Handphone maks 3 digit').max(4, 'No Handphone maks 4 digit'),
        // MobilePhone: Yup.number().typeError('Harus diisi dengan angka').required('No Handphone harus diisi').max(9999999999999, 'No Handphone maks 14 digit'),
        // MobilePhone: Yup.string().required('No Handphone harus diisi').matches(/^[0-9]+$/, "Must be only digits").min(10, 'No Handphone min 10 digit').max(14, 'No Handphone maks 14 digit'),
        Email: Yup.string().required('Email harus diisi').email('Email tidak valid'),

        ResidentialAddressLine1: Yup.string().trim().min(4, 'Minimal 4 karakter').required('Harus diisi').max(40, 'Maksmimal 200 karakter'),
        ResidentialAddressprovinceId: Yup.string().required('Harus diisi'),
        ResidentialAddressCityId: Yup.string().required('Harus diisi'),
        ResidentialAddressPostalCode: Yup.number().required('Kode Pos harus diisi').max(99999, 'Kode Pos harus 5 digit').min(10000, 'Kode Pos harus 5 digit')

    });

    Step3Schema = Yup.object().shape({
        OccupationId: Yup.string().required('Pekerjaan harus dipilih'),
        OccupationOthers: Yup.string()
            .when('OccupationId', {
                is: (OccupationId) => OccupationId === "12",
                then: Yup.string().trim().required('Harus diisi').max(30, 'Maksmimal 30 karakter')
            }),
        BusinessFieldText: Yup.string().required('Bidang Usaha Harus diisi').max(20, 'Maksimal 20 karakter'),
        PositionText: Yup.string().required('Bidang Usaha Harus diisi').max(30, 'Maksimal 30 karakter'),
        IncomePerAnnumId: Yup.string().required('Penghasilan Per Tahun harus dipilh'),
        FundSourceId: Yup.string().required('Sumber Penghasilan harus diisi'),
        FundSourceOthers: Yup.string()
            .when('FundSourceId', {
                is: (FundSourceId) => FundSourceId === "1",
                then: Yup.string().trim().required('Harus diisi').max(15, 'Maksimal 15 karakter')
            }),
        CompanyName: Yup.string().trim().required('Nama Tempat Bekerja harus diisi').matches(/^[a-z &A-Z]+$/, "Only alpha character").min(2, 'Minimal 2 karakter'),
        CompanyAddress: Yup.string().trim().required('Alamat harus diisi').matches(/^[A-Za-z ].*/, 'Karakter pertama harus bentuk huruf').max(40, 'Maksimal 40 karakter'),
        CompanyPhoneNumber: Yup.string().max(10, "Maksimal 10 karakter").required('No. Telp harus diisi'),
        CompanyAreaPhoneNo: Yup.string().max(4, "Maksimal 4 karakter"),
        LengthOfWork: Yup.string().required('Harus diisi').max(99, 'Maksimal 99 ').min(1).matches(/^[0-9]+$/, "Hanya boleh diisi angka"),
    });

    Step4AgreementKetentuan = Yup.object().shape({
        AgreementKetentuan1: Yup.string().required('Anda harus menyetujui Pernyataan')
    });

    Step4AgreementKetentuan2 = Yup.object().shape({
        AgreementKetentuan2: Yup.string().required('Anda harus menyetujui Syarat & Ketentuan')
    });

    Step5Summary = Yup.object().shape({
        AgreementPernyataan1: Yup.string().required('Anda harus menyetujui Pernyataan'),
        AgreementPernyataan2: Yup.string().required('Anda harus menyetujui Pernyataan')
    });


    schemaArray = [this.Step1Schema, this.Step2Schema, this.Step3Schema, this.Step4AgreementKetentuan, this.Step4AgreementKetentuan2, this.Step5Summary];

    nextPage = (errors, isvalid, setFieldTouched) => {
        console.log(errors);
        console.log('isValid: ' + isvalid);
        for (var propt in defaultValue) {
            setFieldTouched(propt, true, true);
        }
        const isValid = !Object.keys(errors).length;
        if (isValid) {
            this.setState(state => ({ page: Number(state.page) + 1 }));
            var myPage = Number(localStorage.getItem('page'));
            localStorage.setItem('page', myPage + 1);
        } else {
            alert('Mohon lengkapi data terlebih dahulu!');
        }

    };

    scrollToBottom = () => {
        this.el.scrollIntoView({ behavior: "smooth" });
    };


    onOccupationChange = (e, setFieldValue) => {
        if (e.target.value !== '') {
            this.props.requestPositions(e.target.value);
        }
        setFieldValue('OccupationId', e.target.value);
        setFieldValue('PositionId', '');
        setFieldValue('BusinessFieldId', '');
    };

    onPositionChange = (e, occupationId, setFieldValue) => {
        if (e.target.value !== '') {
            this.props.requestBusinessFields(e.target.value, occupationId);
        } else {

        }
        setFieldValue('PositionId', e.target.value);
        setFieldValue('BusinessFieldId', '');
    };


    onTINSSNMandatoryChange = (e, setFieldValue) => {
        setFieldValue('TINSSNMandatory', e.target.value);
        if (e.target.value === "2") {
            setFieldValue('TINSSN', '');
        }
    };

    onProvinceChange = (e, setFieldValue) => {
        this.props.requestCities(e.target.value);
        setFieldValue('ProvinceId', e.target.value);
    };

    onResidentialProvinceChange = (e, setFieldValue) => {
        this.props.requestResidentialCities(e.target.value);
        setFieldValue('ResidentialAddressprovinceId', e.target.value);
    };

    onCorrespondenceProvinceChange = (e, setFieldValue) => {
        this.props.requestCorrespondenceCities(e.target.value);
        setFieldValue('CorrespondenceAddressprovinceId', e.target.value);
    };

    backPage = (isValid, setFieldTouched) => {
        var myPage = Number(localStorage.getItem('page'));
        localStorage.setItem('page', myPage - 1);
        this.setState(state => ({ page: state.page - 1 }));
        for (var propt in defaultValue) {
            setFieldTouched(propt, true, true);
        }
    };

    finish = () => {
        const loopCheckRegisterStatus = setInterval(() => this.checkRegisterStatus(loopCheckRegisterStatus), 10000);
    };



    async sendData(values) {
        try {
            await this.props.updateCustomer(values);

            this.setState({ isLoading: false });
            if (this.props.pengkinianData.ResponseCode == "00") {
                window.location = "/pengkinian-data-succeed/" + this.props.pengkinianData.Ref;
            } else {
                alert(this.props.pengkinianData.ResponseCode + ': ' + this.props.pengkinianData.Message);
            }

        } catch (err) {
            this.setState({ isLoading: false, registerError: true });

        }

    };

    takePhoto = (a) => {
        this.setState({ openModalPhoto: true, PhotoId: a });
    };

    onSnapPhoto = (dataUri, setFieldValue) => {
        this.setState({ [this.state.PhotoId]: dataUri });
        localStorage.setItem([this.state.PhotoId], dataUri);
        setFieldValue(this.state.PhotoId, dataUri);
        this.setState({ openModalPhoto: false });
    };

    onCloseMessage = () => {
        this.setState({ registerError: false });
    };

    checkRegisterStatus = (loopCheckRegisterStatus) => {
        console.log(this.props.register);
        // console.log('status:::' + this.props.registerStatus);

        if (this.props.registerStatus === "FINISH") {
            clearInterval(loopCheckRegisterStatus);
            localStorage.clear();
            window.location = '/register-succeed';
        }
        if (this.props.register != null) {
            // by pass check looping status
            // clearInterval(loopCheckRegisterStatus);
            // window.location = '/register-succeed';
            // bypass check looping status

            this.props.checkRegisterStatus(this.props.register.id);
        }
    };

    reloadCaptcha = () => {
        this.setState({ imageHash: Date.now() });
    }

    render() {
        const { page } = this.state;
        const { occupations, positions } = this.props;
        const { schemaArray, state, props } = this;
        return (

            <Container>
                <h1>Pengkinian Data</h1>
                <Prompt
                    when={this.state.page >= 0}
                    message='Data yang Anda masukan belum tersimpan, apakah Anda yakin ingin meninggalkan situs ini?'
                />

                <Iframe source={this.state.iframeSrc} />

                <Modal isOpen={this.state.isLoading}>
                    <ModalBody className="text-center">
                        <Spinner color="success" /><br />Pendaftaran Anda sedang diproses, mohon tunggu..
                    </ModalBody>
                </Modal>

                {this.state.registerError ?
                    <Modal isOpen={true}>
                        <ModalHeader size={"sm"} toggle={() => this.onCloseMessage()}>{this.props.pengkinianData.title}</ModalHeader>
                        <ModalBody className="text-center">
                            {this.props.pengkinianData.errors != null ?
                                <ul>
                                    {Object.keys(this.props.pengkinianData.errors).map(function (key) {
                                        return <li className={"text-danger"}>{this.props.pengkinianData.errors[key][0]}</li>
                                    }, this)
                                    }
                                </ul>
                                : null}

                            <span className={"text-danger"}> {this.props.pengkinianData.message}</span>
                        </ModalBody>
                        <ModalFooter>
                            <Button size={"sm"} color="primary" onClick={() => this.onCloseMessage()}>Close</Button>
                        </ModalFooter>
                    </Modal>
                    : null}

                {this.state.page >= -1 && this.state.page < 0 ? (
                    <VerifikasiDataPribadi nowRegister={this.nowRegister} />
                ) : null}
                {this.state.errors.length > 0 ? (
                    <div class="alert alert-danger alert-dismissible fade show" >
                        <strong>Error!</strong> A problem has been occurred while submitting your data.
                        <ul>{this.state.errors.map((item, key) => <li>{item}</li>)}
                        </ul>
                    </div>
                ) : null}
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize
                    onSubmit={values => {
                        // console.log(values);
                        // this.props.requestJabatans(0, values);
                        this.setState({ isLoading: true });
                        // this.props.createCustomer(values);
                        this.sendData(values);
                        // this.sendDataBypassDigisign(values);
                        // this.finish();
                    }}
                    validationSchema={schemaArray[Number(page)]}
                >
                    {({ errors, touched, values, isValid, setFieldValue, setFieldTouched }) => (

                        <Form autoComplete="off">

                            {/* {this.state.page >= 0 && this.state.page !== 7 ? ( // 0
                                <DukcapilValidation />
                            ) : null} */}


                            {this.state.page == 0 ? (// {this.state.page >= 0 && this.state.page !== 7 ? ( // 0
                                <Fade in={this.state.page == 0}>
                                    {/* <Button type="button" className="btn btn-secondary btn-sm" onClick={() => this.copyData(setFieldValue, values)} >Copy Data</Button> */}

                                    <Page1PersonalData errors={errors} touched={touched} values={values} state={state} onGantiPhotoKTP={this.onGantiPhotoKTP} onGantiPhotoNPWP={this.onGantiPhotoNPWP} setFieldValue={setFieldValue} />
                                </Fade>
                            ) : null}

                            {this.state.page == 1 ? ( // {this.state.page >= 1 && this.state.page !== 7 ? (
                                <Fade in={this.state.page == 1}>
                                    <Page2Address errors={errors} touched={touched} values={values} state={state} props={props}
                                        onProvinceChange={this.onProvinceChange} onResidentialProvinceChange={this.onResidentialProvinceChange}
                                        setFieldValue={setFieldValue}
                                        requestResidentialCities={this.props.requestResidentialCities}
                                        onResidentIdemIdentity={this.onResidentIdemIdentity}
                                    />
                                </Fade>
                            ) : null}

                            {this.state.page == 2 ? ( //  {this.state.page >= 3 && this.state.page !== 7 ? (
                                <Fade in={this.state.page == 2}>
                                    <Page4Job errors={errors} touched={touched} values={values} state={state} occupations={occupations}
                                        positions={positions} props={props} setFieldValue={setFieldValue}
                                        onCorrespondenceProvinceChange={this.onCorrespondenceProvinceChange}
                                        onPositionChange={this.onPositionChange}
                                        onOccupationChange={this.onOccupationChange} />
                                </Fade>
                            ) : null}

                            {this.state.page == 3 ? (
                                <Fade in={this.state.page == 3}>
                                    <Page5AgreementPernyataan onAgree={this.onAgree} setFieldValue={setFieldValue} errors={errors} touched={touched} values={values} />
                                </Fade>
                            ) : null}

                            {this.state.page == 4 ? (
                                <Fade in={this.state.page == 4}>
                                    <Page5AgreementKetentuan onAgree={this.onAgree} setFieldValue={setFieldValue} errors={errors} touched={touched} values={values} />
                                </Fade>
                            ) : null}

                            {this.state.page == 5 ? (
                                <React.Fragment>
                                    <Fade in={this.state.page == 5}>
                                        <Page6Summary onAgree={this.onAgree} errors={errors} touched={touched} values={values} state={state} props={props} occupations={occupations} setFieldValue={setFieldValue} reloadCaptcha={this.reloadCaptcha} />
                                    </Fade>
                                    <Button
                                        type="button"
                                        color="primary"
                                        onClick={() => this.backPage(isValid, setFieldTouched)}>&lt; Sebelumnya</Button><span> </span>

                                    <Button
                                        color="primary"
                                        type="submit"
                                    >Kirim Data</Button>

                                </React.Fragment>
                            ) : (
                                null
                            )}


                            {(this.state.page > 0 && this.state.page < 5) ? (
                                <React.Fragment>
                                    <Button
                                        type="button"
                                        color="primary"
                                        onClick={() => this.backPage(isValid, setFieldTouched)}>&lt; Sebelumnya</Button><span> </span>
                                </React.Fragment>
                            ) : null}

                            {this.state.page >= 0 && this.state.page != 5 ? (
                                <Button
                                    type="button"
                                    color="primary"
                                    onClick={() => this.nextPage(errors, isValid, setFieldTouched)}>Selanjutnya &gt; </Button>
                            ) : (null)}
                            <Persist name="registrasi" />
                        </Form>
                    )}
                </Formik>
                <div ref={el => { this.el = el; }} />
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    occupations: state.occupations.entities,
    positions: state.positions.entities,
    businessFields: state.businessFields.entities,
    provinces: state.province.entities,
    cities: state.city.entities,
    residentialCities: state.city.residentialCitiesEntities,
    correspondenceCities: state.city.correspondenceCitiesEntities,
    banks: state.bank.entities,
    pengkinianData: state.pengkinianData.entity,
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestOccupations: occupationAction.requestOccupations,
        requestPositions: positionActions.requestPositions,
        requestBusinessFields: businessFieldActions.requestBusinessFields,
        requestProvinces: provinceActions.requestProvinces,
        requestCities: cityActions.requestCities,
        requestResidentialCities: cityActions.requestResidentialCities,
        requestCorrespondenceCities: cityActions.requestCorrespondenceCities,
        requestBanks: bankActions.requestBanks,
        createCustomer: registerActions.createCustomer,
        customerActivation: registerActions.customerActivation,
        checkRegisterStatus: registerActions.checkRegisterStatus,
        updateCustomer: pengkinianDataActions.updateCustomer,
    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PengkinianData);



// WEBPACK FOOTER //
// ./src/components/PengkinianData/PengkinianData.js